import React, { useState } from 'react';
import { CONSTANTS_MODE } from "../../utils/constants";
import {Button, Form, FormInput} from "shards-react";
const { api } = CONSTANTS_MODE;

async function loginUser(credentials) {
  return fetch(`${api}/api/login_check`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(credentials)
  })
    .then(data => data.json());
}

const GuestAuth = () => {
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    const token = await loginUser({
      username,
      password
    });

    if (token.token) {
      const jwtToken = JSON.stringify(token.token);
      localStorage.setItem('accessToken', jwtToken);
      window.location.replace('/dashboard');
    }
  }

  return (
      <div className = "modal-dialog">
        <div className = "modal-content">
          <h1 className = "modal-header justify-content-center">Please Log In</h1>
          <Form onSubmit = { handleSubmit }>
            <div className = "modal-body mx-3">
              <div className = "md-form mb-3">
                <span> Username </span>
                <FormInput type = "text" onChange={e => setUserName(e.target.value)}/>
              </div>
              <div className = "md-form mb-4">
                <span> Password </span>
                <FormInput type = "password" onChange={e => setPassword(e.target.value)}/>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <Button type="submit" className="block-center"> Sign in </Button>
            </div>
          </Form>
        </div>

      </div>
  )
}

export default GuestAuth;



// WEBPACK FOOTER //
// ./src/views/Auth/GuestAuth.js